import { OnlineOnlyFunctionalityError } from "@archipad/errors/errors-archipad";
import { fromEvent, map, merge, Observable, of, startWith } from "rxjs";

export class OfflineService {

    private _onlineStatus$: Observable<boolean> = this.createOnlineStatusObservable();

    constructor() {
        this._onlineStatus$ = this.createOnlineStatusObservable();
    }

    public isOnline() {
        // Node exposes a `navigator` global without `onLine` (report-generator): assume online.
        if (typeof navigator === 'undefined' || typeof navigator.onLine !== 'boolean') {
            return true;
        }
        return navigator.onLine;
    }

    public isOffline() {
        return !this.isOnline();
    }

    public guardOnlineOnly() {
        if (!this.isOnline()) {
            throw new OnlineOnlyFunctionalityError();
        }
    }

    public get onlineStatus$(): Observable<boolean> {
        return this._onlineStatus$;
    }

    private createOnlineStatusObservable(): Observable<boolean> {
        if (typeof window === 'undefined') {
            console.warn('OfflineService: window is undefined, defaulting to online status observable of true');
            return of(true);
        }
        const online$ = fromEvent(global.window ?? null, 'online').pipe(map(() => true));
        const offline$ = fromEvent(global.window ?? null, 'offline').pipe(map(() => false));
        
        return merge(online$, offline$).pipe(
            startWith(this.isOnline()),
        )
    }
      
}

const offlineService = new OfflineService();
export default offlineService;
